import { showNotification } from '../common/notifications/notifications';

export const errorAlert = (message) => {
    if (message !== "Refresh token is not in database!") {
        showNotification({notificationType: 'NO_CONNECTION', orderedMessage: message});
    }

    return {
        status: "Failed"
    };
};

export const badRequestError = (error) => {
    if (error.response) { 
        // Handle 400 errors specifically
        if (error.response.status === 400) {
            return errorAlert(error.response.data?.message || "Bad Request");
        }

        if (error.response.status === 429) {
            return errorAlert(error.response.data?.message || "Too many requests, please try again later.");
        }

        return errorAlert(error.response.data?.message || "Unexpected error");
    } else if (error.request) { 
        // The request was made but no response was received
        return errorAlert(error?.request);
    } else if (error.message) {
        // Error on setting up the request
        return errorAlert(error?.message);
    } else {
        // Something happened in setting up the request that triggered an Error
        return errorAlert("Network error or server not responding");
    }
}